import { render, staticRenderFns } from "./statisticPerson.vue?vue&type=template&id=3f7876f2&"
import script from "./statisticPerson.vue?vue&type=script&lang=js&"
export * from "./statisticPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports